module.exports = "/assets/a9280e3ba39cfbdbc102e759e6a92b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-details-flight/assets/icon-train.png
// module id = 936
// module chunks = 0